import React from 'react'
import './NewSkills.css'
import html from './Assets/html.png'
import css from './Assets/css.png'
import js from './Assets/js.png'
import mongo from './Assets/mongo.png'
import express from './Assets/express.png'
import react from './Assets/react.png'
import node from './Assets/node.png'
import git from './Assets/git.png'
import chakra from './Assets/chakra.png'
import bootstrap from './Assets/bootstrap5.png'
import material from './Assets/material.png'
import tailwind from './Assets/tailwind.png'

export default function NewSkills() {
    return ( 
        <div className="col-lg-12" id='skill'>
        {/* <div className="col-lg-12" style={{backgroundColor:"blue"}}> */}

        <div className='container py-4' >
            <div className='skills_heading mt-4 text-center my-5'><h1 className='expertise mb-4'>My Expertise</h1>
            <h4 className='expertise_des'>"Expertise is a result of long-term commitment to a task,<br /> coupled with a willingness to learn new techniques."</h4></div>
            <div className="col-lg-8 col-md-8 col-10 mx-auto">
                <div className="row my-4">
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={html} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={css} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={js} className="img-fluid skill_img" alt="" />
                    </div>
                </div>
            </div>
            <div className="col-lg-8 col-md-8 col-10 mx-auto">
                <div className="row my-4">
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={mongo} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={express} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={react} className="img-fluid skill_img" alt="" />
                    </div>
                </div>
            </div>
            <div className="col-lg-8 col-md-8 col-10 mx-auto">
                <div className="row my-4">
                    <div className="col-lg-2 col-md-2 col-4 d-flex align-items-center mx-auto">
                        <img src={node} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={git} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={chakra} className="img-fluid skill_img" alt="" />
                    </div>
                </div>
            </div>
            <div className="col-lg-8 col-md-8 col-10 mx-auto">
                <div className="row my-4">
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={bootstrap} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={material} className="img-fluid skill_img" alt="" />
                    </div>
                    <div className="col-lg-2 col-md-2 col-4 mx-auto">
                        <img src={tailwind} className="img-fluid skill_img" alt="" />
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}





